
//Display Flat Progress for Programs
class Discover extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            search: "",
            lastSearch: "",
            results_organizations: [],
            results_users: [],
            results_badges: [],
            results_skillholders: [],
            results_skills: []
        };
    }

    componentDidMount() {

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.fetchData();
        }
    }
    
    fetchData() {
        // note to self: /api/v20/portfolio/skill?pattern=test
        //TODO move this into routing if accepted
        var discoverroutes = {
            discover_badges: "/discover/badges",
            discover_users: "/discover/users",
            discover_organizations: "/discover/organizations",
            discover_skillholders: "/discover/skillholders",
            discover_skills: "/portfolio/skill"
        }

        let _self = this;
        this.setState({ loading: true, lastSearch: this.state.search });

        var params = {
            page: 1,
            page_size: 9,
            search: this.state.search,
            pattern: this.state.search
        }

        //Get Org
        httpGet(buildRoute(discoverroutes.discover_organizations) + formatParams(params)).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({ 
                    results_organizations: response.results
                });
            })
        .catch(
            function(reason) {
                console.error('Error searching orgs.', reason);
                alertify.error("Error searching orgs.")
            });
        
        //Get Badges
        httpGet(buildRoute(discoverroutes.discover_badges) + formatParams(params)).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({ 
                    results_badges: response.results
                });
            })
        .catch(
            function(reason) {
                console.error('Error searching badges.', reason);
                alertify.error("Error searching badges.")
            });
        
        //Get users
        httpGet(buildRoute(discoverroutes.discover_users) + formatParams(params)).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({ 
                    results_users: response.results
                });
            })
        .catch(
            function(reason) {
                console.error('Error searching users.', reason);
                alertify.error("Error searching users.")
            });
        
        //Get users
        httpGet(buildRoute(discoverroutes.discover_skillholders) + formatParams(params)).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({ 
                    results_skillholders: response.results
                });
            })
        .catch(
            function(reason) {
                console.error('Error searching skill holders.', reason);
                alertify.error("Error searching skill holders.")
            });
        
        //Get skills
        httpGet(buildRoute(discoverroutes.discover_skills) + formatParams(params)).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({ 
                    results_skills: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error searching skills.', reason);
                alertify.error("Error searching skills.")
            });
    }

    render() {
        
        return (
            <div>
                <div className="filterbox">
                    <div className="form--inline text--center">
                        <label htmlFor="search" className="text--xl"><Icon classes="icon-search" title="Search Term" /></label>
                        <input type="search" className="input--underline input--limited text--xl" id="search" name="search" defaultValue="" onChange={this.handleInputChange} onKeyPress={this.handleKeyPress} placeholder="Search for Badges, Skills etc" style={ {width: "400px"} } />
                        <button type="button" className="button--primary button--skinny" onClick={this.fetchData}>Go</button>
                    </div>
                </div>

                {
                    this.state.lastSearch != "" &&
                    this.state.results_organizations.length == 0 && 
                    this.state.results_badges.length == 0 && 
                    this.state.results_users.length == 0 && 
                    this.state.results_skillholders.length == 0 && 
                    this.state.results_skills.length == 0 && (
                        <p className="introduction text--muted text--loosetop text--center">No results.</p>
                    )
                }

                <DiscoverOrganizations items={this.state.results_organizations} />
                <DiscoverBadges items={this.state.results_badges} />
                <DiscoverUsers items={this.state.results_users} />
                <DiscoverSkillholders items={this.state.results_skillholders} />
                <DiscoverSkills items={this.state.results_skills} />

            </div>
            
        );
        
    }
}

//TODO: complete the generic "set" component, replace the repetitive specific ones below?

// Orgs
function DiscoverOrganizations(props) {
    if(props.items.length > 0){
        const items = props.items.map((item,index) => <DiscoverOrganizationsItem item={item} key={item.id} /> );
        return (
            <div>
                <h1 className="h3">Issuing Organizations</h1>
                <p className="text--information text--sm">Possible workflows: jump to badge offerings? See earners with their badges?</p>
                <div className="card-container card-container--grid">{items}</div>
            </div>
        );
    } else {
        return (null);
    }
    
}

function DiscoverOrganizationsItem(props) {
    return (
        <div data-id={props.item.id} className="card card--rounded">
            <div className="card-content">
                <h4 className="h5"><img onError={() => this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='} src={props.item.image} className="avatar" alt={props.item.name + "'s Logo"} /> <VerifiedShield verified={props.item.verified} /> {props.item.name}</h4>
                <p>{props.item.description}<br /><a className="text--sm" href={props.item.website}>{props.item.website}</a></p>
                <p><a className="button button--skinny button--sm" href={props.item.about_url}>View &rarr;</a></p>
            </div>
        </div>
    );
}

// Badges
function DiscoverBadges(props) {
    if(props.items.length > 0){
        const items = props.items.map((item,index) => <DiscoverBadgesItem item={item} key={item.id} /> );
        return (
            <div>
                <h1 className="h3">Open Badges</h1>
                <p className="text--secondary text--sm text--loosebottom">Possible workflows: List earners? Find similar badges? Find relevant occupations? New window or modal?</p>
                <div className="card-container card-container--grid">{items}</div>
            </div>
        );
    } else {
        return (null);
    }
    
}

function DiscoverBadgesItem(props) {
    return (
        <div data-id={props.item.id} className="card card--rounded">
            <div className="card-content">
                <h4 className="h5"><BadgeDisc image={props.item.image} name={props.item.name} classes="badge-disc--large" /> {props.item.name}</h4>
                <p className="badge-description">{props.item.description}</p>
                <p><a className="button button--skinny button--sm" href={props.item.view_url}>View &rarr;</a> <a href={props.item.url} className="float--right"><img src={mantl.static_url + "assets/images/openbadges-symbol.svg" } className="icon--svg--small" alt="Open Badge" /> {"{JSON}"}</a></p>
            </div>
        </div>
    );
}

// Users
function DiscoverUsers(props) {
    if(props.items.length > 0){
        const items = props.items.map((item,index) => <DiscoverUsersItem item={item} key={item.id} /> );
        return (
            <div>
                <h1 className="h3">Users</h1>
                <p className="text--secondary text--sm text--loosebottom">Find users based on their name/title/bio. If I find somebody, what do I do with the discovery?</p>
                <div className="card-container card-container--grid">{items}</div>
            </div>
        );
    } else {
        return (null);
    }
    
}

function DiscoverUsersItem(props) {
    let portfolioURL = buildView(mantlroutes.portfolio_theirs, { portfolioid: props.item.portfolio_user });
    return (
        <div data-id={props.item.id} className="card card--rounded">
            <div className="card-content">
                <a href={portfolioURL}><img src={props.item.avatar} className="avatar" alt={props.item.first_name + "'s Avatar"} /> {props.item.first_name} {props.item.last_name}</a>
                <p className="text--sm"><b>{props.item.professional_title}</b></p>
                <p className="text--sm">{props.item.bio}</p>
                <a className="button button--skinny button--sm" href={portfolioURL}>Portfolio &rarr;</a> 
            </div>
        </div>
    );
}

// Skill Holders
function DiscoverSkillholders(props) {
    if(props.items.length > 0){
        const items = props.items.map((item,index) => <DiscoverSkillholdersItem item={item} key={item.id} /> );
        return (
            <div>
                <h1 className="h3">Skill Holders (Portfolios)</h1>
                <p className="text--secondary text--sm text--loosebottom">Find portfolios based on search (inside evidence/skills etc). Next steps from here: list their skills and evidence in a modal? Bookmark? Save? Message? If I find somebody, what do I do with the discovery?</p>
                <p className="text--secondary text--sm text--loosebottom">We could also list target occupations here (once we have UI for the user to set those up) and even self-declared skills (no evidence).</p>
                <div className="card-container card-container--grid">{items}</div>
            </div>
        );
    } else {
        return (null);
    }
    
}

function DiscoverSkillholdersItem(props) {

    const [skillsData, setData] = React.useState([]);
    React.useEffect(() => {
        httpGet(props.item.skills_list).then(
            function(value) {
                let response = JSON.parse(value);
                setData(response);
            })
        .catch(
            function(reason) {
                console.error('Error fetching skills.', reason);
            })
    }, []); //provide an empty array as second argument to the effect hook to avoid activating it on component updates but only for the mounting of the component

    return (
        <div data-id={props.item.id} className="card card--rounded">
            <div className="card-content">
                <p><a href={props.item.home_url}><img src={props.item.user.avatar} className="avatar" alt={props.item.user.first_name + "'s Avatar"} /> {props.item.user.full_name}</a></p>
                <p>Has Evidence for <span className="flag flag--badged">{skillsData.length}</span> Skills</p>
                <ul className="collection">
                {skillsData.map(skill => (
                    <li className="collection-item" key={skill.id}>
                        <b>{skill.tag}</b>
                        <div className="skills-list-stats">
                            <span className="skills-list-work" title="" data-popover="tooltip" data-placement="top" data-original-title="Work Samples">Work Samples</span>
                            <b className="">{skill.work_count} </b>
                            <span className="skills-list-badges" title="" data-popover="tooltip" data-placement="top" data-original-title="Badges">Badges</span>
                            <b className=""> {skill.badge_count} </b>
                            <span className="skills-list-endorsements" title="" data-popover="tooltip" data-placement="top" data-original-title="Endorsements">Endorsements</span>
                            <b className=""> {skill.endorse_count} </b>
                        </div>
                    </li>
                ))}
                </ul>
            </div>
        </div>
    );
}

// Skills
function DiscoverSkills(props) {
    if(props.items.length > 0){
        const items = props.items.map((item,index) => <DiscoverSkillsItem item={item} key={item.id} /> );
        return (
            <div>
                <h1 className="h3">Skills (General Labels that Exist for Tagging)</h1>
                <p className="text--secondary text--sm text--loosebottom">Possible workflows: find relevant occupations? Find people with evidence of this specific item? Get report about X (maybe frequency of evidence?)?</p>
                <div className="column-flow-3">{items}</div>
            </div>
        );
    } else {
        return (null);
    }
    
}

function DiscoverSkillsItem(props) {
    return (
        <div data-id={props.item.id}><img src={mantl.static_url + "assets/images/icon-skills.svg" } className="icon--svg" alt="Skills Icon" /> <span className="flag flag--badged">{props.item.tag}</span></div>
    );
}
